import { useMemo } from 'react';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import { useBilling } from '@/modules/billing/hooks/useBilling';
import { STRIPE_PUBLIC_KEY } from '@/util/constants';

const defaultPromise = STRIPE_PUBLIC_KEY ? loadStripe(STRIPE_PUBLIC_KEY) : null;

export const WithStripeElements = <P extends Record<string, unknown>>(
  Component: React.ComponentType<P>
) => {
  const Wrapped = (props: P) => {
    const { billingState } = useBilling();
    const stripeAccount = billingState?.stripe_account_id;

    const stripePromise = useMemo(
      () =>
        STRIPE_PUBLIC_KEY && stripeAccount
          ? loadStripe(STRIPE_PUBLIC_KEY, { stripeAccount })
          : defaultPromise,
      [stripeAccount]
    );

    if (!stripePromise) {
      return <Component {...props} />;
    }

    return (
      <Elements stripe={stripePromise}>
        <Component {...props} />
      </Elements>
    );
  };

  return Wrapped;
};
